
import { defineComponent } from 'vue';
import vClickOutside from 'v-click-outside';

export default defineComponent({
  data() {
    return {
      enabled: false,
      open: false,
    };
  },
  directives: {
    'on-click-outside': vClickOutside,
  },
  methods: {
    changed() {
      this.$emit('changed', this.enabled);
    },
    closePopup() {
      this.open = false;
    },
  },
  watch: {
    enabled: [
      {
        immediate: true,
        handler: 'changed',
      },
    ],
  },
  props: {
    positionLeft: {
      type: Boolean,
      default: false,
    },
  },
});
